import { useId, useLayoutEffect, useRef, useState } from 'react';

export const Curve = ({
  fromRef,
  toRef,
  label,
  ...pathProps
}: {
  fromRef: React.RefObject<HTMLDivElement | null>;
  toRef: React.RefObject<HTMLDivElement | null>;
  label?: string;
} & React.JSX.IntrinsicElements['path']) => {
  const id = useId();
  const ref = useRef<SVGGElement | null>(null);
  const [d, setD] = useState<string>('');

  useLayoutEffect(() => {
    let newD = '';

    if (fromRef.current && toRef.current && ref.current) {
      const parentSvg = ref.current.closest('svg');
      if (parentSvg) {
        const { left, top } = parentSvg.getBoundingClientRect();
        const fromCoord = fromRef.current.getBoundingClientRect();
        const toCoord = toRef.current.getBoundingClientRect();

        const pointA = {
          x:
            fromCoord.left +
            (fromCoord.left < toCoord.left ? fromCoord.width : 0) -
            left,
          y: fromCoord.top + fromCoord.height / 2 - top,
        };

        const pointB = {
          x:
            toCoord.left +
            (fromCoord.left > toCoord.left ? toCoord.width : 0) -
            left,
          y: toCoord.top + toCoord.height / 2 - top,
        };

        const from = pointA.x < pointB.x ? pointA : pointB;
        const to = pointA.x < pointB.x ? pointB : pointA;

        newD = `M${from.x} ${from.y}q${(to.x - from.x) / 4} 0, ${
          (to.x - from.x) / 2
        } ${(to.y - from.y) / 2} T${to.x}  ${to.y}`;
      }
    }

    requestAnimationFrame(() => {
      setD(newD);
    });
  }, [fromRef, toRef]);

  return (
    <g ref={ref}>
      {!!d && (
        <>
          <path {...pathProps} id={id} d={d} />
          {!!label && (
            <text>
              <textPath
                href={`#${id}`}
                stroke="transparent"
                fill="white"
                textAnchor="middle"
                startOffset="50%"
                alignmentBaseline="after-edge"
              >
                {label}
              </textPath>
            </text>
          )}
        </>
      )}
    </g>
  );
};
